// extracted by mini-css-extract-plugin
export default {"folders":"Folders_folders__inJJz","folder":"Folders_folder__XmXe1","clicked":"Folders_clicked__Kd-N4"};